// StableSurfaces Dependent id brands and parse (docs/stable-surfaces/model.md). No runtime imports (browser graph).

declare const ID: unique symbol
/** A Surface-space value: D1; D3 view id; D5 entry; D13 `surfaceId`; D14–D16. */
export type SurfaceId = string & { readonly [ID]: 'surface' }
/** A Definition-space value: D6, D7, D8; D9 entry `id`; D13 `path[].componentId`; I11 `controlId`. */
export type DefinitionId = string & { readonly [ID]: 'definition' }
/** Unbranded text: the only input of a parse. */
export type IdText = string & { readonly [ID]?: never }

/** Parse: stored, captured, model-written or observed text as an id of the space. No transformation. */
export function parseSurfaceId(text: IdText): SurfaceId {
  return text as string as SurfaceId
}

export function parseDefinitionId(text: IdText): DefinitionId {
  return text as string as DefinitionId
}

/** Cross the spaces at a nested Surface: its definition id is its Surface id (copy). */
export function surfaceDefinitionId(id: SurfaceId): DefinitionId {
  return id as string as DefinitionId
}

/** Cross the spaces at a Surface slot that names a nested Surface or shared-root definition (copy). */
export function definitionSurfaceId(id: DefinitionId): SurfaceId {
  return id as string as SurfaceId
}
